import React, { useContext, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get, isEmpty, uniqBy } from "lodash";
import { Formik } from "formik";
import {
  ManagePlanLayout,
  CsplTable as Table,
  LoaderWrapper,
} from "../../../components";
import { MANAGE_PLAN_ROUTES, getPathWithParam } from "../../../utils";
import {
  useRouterParams,
  useTableChecboxSelect,
  useRequest,
  useDeepEffect,
} from "../../../abstracts";
import {
  getTrusteeCompany,
  listTrustee,
  saveTrusteeToPlan,
} from "../../../services";
import {
  createPlanStore,
  savePlanDetailsAction,
  setManagePlanToastInfo,
} from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";

const AddTrusteeMasterContainer = (props) => {
  const [newFlow] = useState("");
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow } = useRouterParams();
  const [dirtyFlag, setDirtyFlag] = useState(true);
  const [trusteeListData, setTrusteeListData] = useState([]);
  const [trustees, setTrustees] = useState([]);
  const [loading, setLoading] = useState(false);
  useDeepEffect(() => {
    setLoading(true);
    listTrustee(parseInt(planId)).then((response) => {
      setTrusteeListData(response.trustees);
    });
    getTrusteeCompany().then((response) => {
      setTrustees(response);
      setLoading(false);
    });
  }, []);
  const {
    data,
    isAllChecked,
    selectedData,
    onHeaderCheckboxClick,
    onRowItemClick,
  } = useTableChecboxSelect({
    response: trustees,
    listData: trusteeListData,
  });
  const newTrusteeLink = getPathWithParam({
    path: MANAGE_PLAN_ROUTES.ADD_TRUSTEE,
    pathParam: [planId],
  });

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.TRUSTEE,
        pathParam: [planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
    },
    {
      link: newTrusteeLink,
      label: "New Trustee",
      variant: "primary",
      type: "button",
    },
  ];

  const columns = [
    {
      label: "",
      className: "",
      columnName: "",
    },
    {
      label: "Trustee Company Name",
      className: "column-trusteeName",
      columnName: "trusteeCompanyName",
    },
    {
      label: "Email",
      className: "column-trusteeMail",
      columnName: "email",
    },
    {
      label: "Phone Number",
      className: "column-trusteePhone",
      columnName: "phoneNumber",
    },
    {
      label: "Added to plan",
      className: "column-trusteePlanAdded",
      columnName: "addedToPlan",
    },
  ];

  const onAddToPlanClick = ({ setFieldError, setFieldTouched }) => {
    setDirtyFlag(true);
    var addToPlanTrustees = uniqBy(
      [...trusteeListData, ...selectedData],
      "id"
    ).map((_) => (_ = { ..._, planId: planId }));
    setLoading(true);
    saveTrusteeToPlan({
      trustees: addToPlanTrustees,
    }).then((response) => {
      setLoading(false);
      if (response.isSuccessful) {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: `Trustee(s) added successfully`,
          })
        );
        props.history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.TRUSTEE,
            pathParam: [planId],
          })
        );
      } else {
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
    });
  };

  return (
    <Formik
      initialValues={{}}
      onSubmit={() => {}}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ setFieldValue }) => {
        return (
          <LoaderWrapper>
            <ManagePlanLayout
              buttons={buttons}
              pageFlow={newFlow || flow}
              blockNavigation={dirtyFlag}
              useBlockNavigationAlways
            >
              <div className="d-flex flex-column">
                <div className="d-flex w-100 align-items-center justify-content-between mb-2">
                  <div style={{ maxWidth: "80%" }}>
                    <p className="selected-title-head py-2">
                      Selected trustee from master to add to plan
                    </p>
                    {selectedData &&
                      selectedData.map((item) => (
                        <span className="selected-table-value">
                          {item.trusteeCompanyName}
                        </span>
                      ))}
                  </div>
                  <div className="">
                    <Button
                      variant="secondary"
                      disabled={
                        !selectedData.some(
                          (data) => data.checked && !data.disabled
                        )
                      }
                      onClick={onAddToPlanClick}
                      className="mr-2"
                    >
                      Add to Plan
                    </Button>
                  </div>
                </div>
                <div className="plan-heading">Master Trustee Information</div>
                <Table isLoading={loading}>
                  <Table.Thead>
                    <Table.Tr>
                      {columns.map((item, index) => {
                        if (index === 0) {
                          return (
                            <Table.Th key={index} className={item.className}>
                              <Form.Check
                                custom
                                name="master-sources-radio-head"
                                type="checkbox"
                                label=""
                                id={`master-sources-radio-head`}
                                onChange={onHeaderCheckboxClick}
                                checked={isAllChecked}
                              />
                            </Table.Th>
                          );
                        }
                        return (
                          <Table.Th key={index} className={item.className}>
                            {item.label}
                          </Table.Th>
                        );
                      })}
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {data.map((trustee, index) => {
                      return (
                        <Table.Tr key={index}>
                          {columns.map((item, cellIndex) => {
                            if (cellIndex === 0) {
                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  <Form.Check
                                    custom
                                    name="master-sources-radio-head"
                                    type="checkbox"
                                    label=""
                                    id={`master-sources-radio-head-${index}`}
                                    checked={trustee.checked}
                                    disabled={trustee.disabled}
                                    onChange={() => {
                                      setDirtyFlag(false); // addition this to triggere dirty check flag
                                      onRowItemClick(trustee);
                                    }}
                                  />
                                </Table.Td>
                              );
                            } else if (item.columnName == "addedToPlan") {
                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  <div style={{ width: "100px" }}>
                                    {trustee.disabled ? "Added" : ""}
                                  </div>
                                </Table.Td>
                              );
                            }
                            return (
                              <Table.Td
                                key={cellIndex}
                                className={item.className}
                              >
                                {!isEmpty(item.link) ? (
                                  <Link
                                    to={getPathWithParam({
                                      path: item.link,
                                      pathParam: [flow, planId, trustee.id],
                                    })}
                                  >
                                    {trustee[item.columnName]}
                                  </Link>
                                ) : item.dataMapper ? (
                                  item.dataMapper[trustee[item.columnName]]
                                ) : (
                                  <AddToolTip name={trustee[item.columnName]} />
                                )}
                              </Table.Td>
                            );
                          })}
                        </Table.Tr>
                      );
                    })}
                  </Table.Tbody>
                </Table>
              </div>
            </ManagePlanLayout>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddTrusteeMasterContainer;
